const getters = {
  token: state => state.user.token,
  phone: state => state.user.phone,
  unionId: state => state.user.unionId,
  products: state => state.pay.products,
  payUrl: state => state.pay.payUrl,
  downloadUrl: state => state.pay.downloadUrl
}
export default getters
